module.exports = __webpack_public_path__ + "static/img/top13.4d3e2ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/top13.png
// module id = udzx
// module chunks = 208